export const paths = {
  home: "/",
  applicationById: "/:id",
  postulate: "/:idapplication/postulate",
  problem: "/:id/problem",
  resource: "/resource/:token",
};